/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, Typography, styled } from "@mui/material";
import { Const } from "const";
import { FC } from "react";

const TitleArea = styled(Box)(({ theme }) => ({
  width: "100%",
  height: 85,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: Const.sidePanelHeaderColor,
}));

interface Props {
  /** Screen title */
  title: string;
}

/**
 * Component of screen title
 * @param{Props} param0 Properties
 * @return{FC} Component
 */
export const Title: FC<Props> = ({ title }: Props) => {
  return (
    <TitleArea>
      <Typography variant="h4">{title}</Typography>
    </TitleArea>
  );
};
